var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"result-img w-100 row space-screen"},[_c('div',{staticClass:"elem-2",staticStyle:{"z-index":"1000"}},[_c('div',{staticClass:"row w-100 m-0"},[_c('div',{staticClass:"text-center w-100"},[_c('img',{staticClass:"card-style-rotate",attrs:{"src":_vm.passListYuki ? `${_vm._detectImg(_vm.passListYuki.image)} ` : '?'}})])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }